import React from 'react';

const CircularHowItWorks = () => {
  const left = [
    {
      title: 'Direct',
      text: 'A I.A. transforma o que você precisa em um pedido estruturado, claro para qualquer fornecedor — menos ruído, menos retrabalho.',
    },
    {
      title: 'Discover',
      text: 'Mapeia novos fornecedores em escala. Sua base deixa de ser uma lista fechada e vira um mercado aberto pro seu comprador qualificar.',
    },
  ];

  const right = [
    {
      title: 'Decision',
      text: 'Equaliza propostas, condições e prazos. Devolve a decisão para quem decide — com os dados certos na mesa.',
    },
    {
      title: 'Deal',
      text: 'O núcleo da negociação. A dgenny conversa e argumenta como uma compradora experiente — no WhatsApp — e entrega o mapa da decisão pro seu comprador bater o martelo.',
    },
  ];

  return (
    <section id="super-agente" className="py-20 md:py-28 bg-muted/40">
      <div className="container px-4 mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-brand-roxo font-semibold text-sm uppercase tracking-wider mb-3">
            Super Agente
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-extrabold text-brand-azul leading-tight">
            Quatro dgennys trabalhando por você
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 items-center">
          <div className="space-y-10 order-2 lg:order-1">
            {left.map((item, idx) => (
              <div key={idx} className="text-left">
                <h3 className="text-brand-roxo font-bold font-display text-lg mb-1">{item.title}</h3>
                <p className="text-brand-azul/75 leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>

          <div className="order-1 lg:order-2 flex justify-center">
            <div className="relative" style={{ width: 340, height: 340 }}>
              <div className="absolute inset-0 rounded-full bg-brand-azul" />
              <div className="absolute inset-6 rounded-full bg-white" />

              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-32 h-32 rounded-full bg-brand-azul flex items-center justify-center shadow-xl">
                  <img
                    src="/brand/icone-rosa.svg"
                    alt="dgenny"
                    className="w-16 h-16 object-contain"
                  />
                </div>
              </div>

              <div className="absolute left-1/2 -translate-x-1/2 -top-4">
                <div className="w-12 h-12 rounded-full bg-brand-roxo text-white flex items-center justify-center shadow font-bold font-display">01</div>
              </div>
              <div className="absolute right-0 top-1/2 -translate-y-1/2 -mr-4">
                <div className="w-12 h-12 rounded-full bg-brand-roxo text-white flex items-center justify-center shadow font-bold font-display">02</div>
              </div>
              <div className="absolute left-1/2 -translate-x-1/2 -bottom-4">
                <div className="w-12 h-12 rounded-full bg-brand-roxo text-white flex items-center justify-center shadow font-bold font-display">03</div>
              </div>
              <div className="absolute left-0 top-1/2 -translate-y-1/2 -ml-4">
                <div className="w-12 h-12 rounded-full bg-brand-roxo text-white flex items-center justify-center shadow font-bold font-display">04</div>
              </div>
            </div>
          </div>

          <div className="space-y-10 order-3">
            {right.map((item, idx) => (
              <div key={idx} className="text-left">
                <h3 className="text-brand-roxo font-bold font-display text-lg mb-1">{item.title}</h3>
                <p className="text-brand-azul/75 leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CircularHowItWorks;
